<template>
    <aside class="aside-content-page" :class="{opacity:opacity}">
        <slot></slot>
    </aside>
</template>

<script>
    import $ from "jquery";
    import Sticky from "sticky-js"
    import {breakpointDown} from "../../libs/Breakpoints";
    import Scrolling from "../../libs/Scrolling"
    import ScrollMagic from "scrollmagic";

    export default {
        props: {},
        data() {
            return {
                filtersSticky: null,
                controller: new ScrollMagic.Controller(),
                marginTop: 0,
                opacity: false,
                activeCount: 0
            };
        },
        methods: {
            stickyAside() {

                this.filtersSticky = new Sticky(".aside-content-page", {
                    marginTop: this.marginTop,
                    // stickyClass: "shadow",
                    wrap: true
                });

            },
            initOpacityScroll() {

                let heightAside = $(".aside-content-page").outerHeight()
                let offset = this.marginTop + heightAside

                $("section.video, section.page-swiper, section.link-to-pages, section.telechargement").each((index, item) => {

                    let heightItem = $(item).outerHeight() + heightAside

                    new ScrollMagic.Scene({
                        triggerElement: item,
                        triggerHook: 0,
                        offset: -offset,
                        duration: heightItem
                    })
                        .addTo(this.controller)
                        // .addIndicators() // add indicators (requires plugin)
                        .on("enter", (event) => {
                            this.activeCount = this.activeCount + 1
                            this.opacity = true
                        })
                        .on("leave", (event) => {
                            this.activeCount = this.activeCount - 1
                            if (this.activeCount === 0) {
                                this.opacity = false
                            }
                        });


                })
            }
        },
        mounted() {
            this.marginTop = Scrolling.getHauteurMenu(20)

            this.stickyAside()
            this.initOpacityScroll()
        },
        destroyed() {
        }
    };
</script>
